<template>
  <button @click="(e) => emit('click', e)" :class="['button', modifierClass]">
    <slot />
  </button>
</template>
<script setup>
import { computed } from 'vue';

const emit = defineEmits(['click']);

const props = defineProps({
  modifier: {
    type: String,
    default: '',
  },
});
const modifierClass = computed(() => {
  return props.modifier ? `button--${props.modifier}` : '';
});
</script>
